import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Button } from "reactstrap";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/images/therusticpaths.png";
import "./header.css";

const nav_links = [
  { path: "/car-rental", display: "Car Rentals" },
  { path: "/tour-packages", display: "Packages" },
  { path: "/destinations", display: "Destinations" },
  { path: "/about-us", display: "About Us" },
  { path: "/blogs", display: "Our Blogs" },
];

const Header = () => {
  const headerRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const stickyHeaderFunc = () => {
      // Ensure headerRef is not null before proceeding
      if (headerRef.current) {
        if (window.scrollY > 80) {
          headerRef.current.classList.add("sticky__header");
        } else {
          headerRef.current.classList.remove("sticky__header");
        }
      }
    };

    // Register the event listener only if headerRef is ready
    if (headerRef.current) {
      window.addEventListener("scroll", stickyHeaderFunc);
    }

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("scroll", stickyHeaderFunc);
    };
  }, []); // Empty dependency array ensures it runs once on mount

  const toggleMenu = () => {
    if (menuRef.current) {
      menuRef.current.classList.toggle("show__menu");
    }
  };

  return (
    <header className="header" ref={headerRef}>
      <Container>
        <Row>
          <div className="nav__wrapper d-flex align-items-center justify-content-between">
            <div className="logo" onClick={() => window.location.href = "/"}>
              <img src={logo} alt="Home" />
            </div>

            <div className="navigation" ref={menuRef} onClick={toggleMenu}>
              <ul className="menu d-flex align-items-center gap-5">
                {nav_links.map((item, index) => (
                  <li className="nav__item" key={index}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => isActive ? "active__link" : ""}
                    >
                      {item.display}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            <div className="nav__right d-flex align-items-center gap-4">
              <Button className="btn primary__btn">
                <Link to={"/contact-us"}>Contact Us</Link>
              </Button>
              <span className="mobile__menu" onClick={toggleMenu}>
                <i className="ri-menu-3-fill"></i>
              </span>
            </div>
          </div>
        </Row>
      </Container>
      <div className="kilo">
        <div id="google_translate_element"></div>
      </div>
    </header>
  );
};

export default Header;
